import Vue from 'vue'
import Form from './form'
import simpleForm from './simple-form'
import Item from './item'
import InputNumber from './input-number'

Vue.component('dynamic-form', Form)
Vue.component('dynamic-form-simple', simpleForm)
Vue.component('dynamic-form-item', Item)
Vue.component('input-number', InputNumber)



// WEBPACK FOOTER //
// ./src/components/dynamic-form/index.js